var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { isDefined } from './helpers';
export function mapOptionFromValue(mapOptionConfig) {
    var _a = mapOptionConfig.options, options = _a === void 0 ? [] : _a, valueKey = mapOptionConfig.valueKey, value = mapOptionConfig.value, isMulti = mapOptionConfig.isMulti, isGrouped = mapOptionConfig.isGrouped;
    var firstOption = options === null || options === void 0 ? void 0 : options[0];
    var hasGroupedOptions = isGrouped &&
        !!(options === null || options === void 0 ? void 0 : options.length) &&
        typeof firstOption === 'object' &&
        'label' in firstOption &&
        'options' in firstOption;
    var getMappedGroupOption = function (options) {
        var mappedGroupOption = options.filter(function (option) {
            if (isMulti && Array.isArray(value)) {
                return value.includes(option[valueKey]);
            }
            return option[valueKey] === value;
        });
        return mappedGroupOption;
    };
    if (hasGroupedOptions) {
        var allOptionsFromValue = options.reduce(function (result, group) {
            return __spread(result, getMappedGroupOption(group.options));
        }, []);
        var singleOption = allOptionsFromValue[0];
        return isMulti ? allOptionsFromValue : singleOption;
    }
    var mappedOption = options.filter(function (option) {
        if (isMulti && Array.isArray(value)) {
            return value.includes(option[valueKey]);
        }
        return option[valueKey] === value;
    });
    return mappedOption;
}
export function getValuesMappedToOptions(getMappedValueConfig) {
    var value = getMappedValueConfig.value, defaultValue = getMappedValueConfig.defaultValue;
    var sharedMapOptionConfig = {
        options: getMappedValueConfig.options,
        valueKey: getMappedValueConfig.valueKey,
        isMulti: getMappedValueConfig.isMulti,
        isGrouped: getMappedValueConfig.isGrouped
    };
    var valueMappedToOption = isDefined(value)
        ? mapOptionFromValue(__assign(__assign({}, sharedMapOptionConfig), { value: value }))
        : undefined;
    var defaultValueMappedToOption = isDefined(defaultValue)
        ? mapOptionFromValue(__assign(__assign({}, sharedMapOptionConfig), { value: defaultValue }))
        : undefined;
    return { valueMappedToOption: valueMappedToOption, defaultValueMappedToOption: defaultValueMappedToOption };
}
//# sourceMappingURL=mappedValues.js.map